export enum DocumentStatus {
  Completed,
  Pending,
  Missing,
  NotApplicable,
}
